<ng-container>
  <form [formGroup]="consolidationDisclosureFg">
    <div class="row">
      <div class="col col-1 pt-3" style="width: 400px">
        <p style="padding: 6px">Informatieverschaffing over consolidatie</p>
      </div>
      <div class="col-2 pt-3">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.consolidationDisclosureFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(0)">
          {{ this.consolidationDisclosureFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            label="In publicatiestukken"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
  <form [formGroup]="consolidationExemptionDescriptionFg">
    <div class="row" *ngIf="isEnkelvoudig">
      <div class="col col-1" style="width: 400px">
        <p style="padding: 6px">Beschrijving van de vrijstelling van consolidatie in verband met toepassing van artikel
          2:408</p>
      </div>
      <div class="col-2">
        <snelstart-ui-button type="secondary"
                             icon="{{ this.consolidationExemptionDescriptionFg.get('value')?.getRawValue() ? 'pencil' : 'plus' }}"
                             class="custom-input-150"
                             (click)="this.showDialog(1)">
          {{ this.consolidationExemptionDescriptionFg.get('value')?.getRawValue() ? 'Aanpassen' : 'Invullen' }}
        </snelstart-ui-button>
      </div>
      <ng-container>
        <div class="col-3">
          <snelstart-ui-select-form-control formControlName="includeInKvkReport"
                                            [options]="this.optionsJaNee"
                                            [required]=true
                                            class="me-1 custom-input-150"
                                            (change)="this.saveForm()"
          >
          </snelstart-ui-select-form-control>
        </div>
      </ng-container>
    </div>
  </form>
</ng-container>

<div *ngIf="this.index === 0">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.consolidationDisclosureFg"
                                                               [title]="'Informatieverschaffing over consolidatie'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>
<div *ngIf="this.index === 1">
  <snelstart-venture-fiscaal-feature-spec-formattedexplanation [(dialogVisible)]="this.dialogVisible"
                                                               [(input)]="this.consolidationExemptionDescriptionFg"
                                                               [title]="'Beschrijving van de vrijstelling van consolidatie in verband met toepassing van artikel 2:408'"
                                                               (inputChange)="this.saveForm()"></snelstart-venture-fiscaal-feature-spec-formattedexplanation>
</div>


